import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-join-2-icon',
  templateUrl: './design-join-2.component.html'
})
export class DesignJoin2Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
